var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"combin-detail"},[_c('el-dialog',{attrs:{"title":"详情","visible":_vm.dialogVisible,"width":"1200px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('a-table',{attrs:{"columns":_vm.detailColumns}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }